;(function($, undefined){

    var rnn = window.rnn,
        log = rnn.logging.log,
        $buyPhotoLink = null,
        $fujiRedirect = null,
        loginForm = "";

    function initPhotos() {
        $buyPhotoLink = $('.photo-buy');

        if ($buyPhotoLink.length) {
            rnn.modules.user.get(function(user) {
                if (!user.authenticated) {
                    $buyPhotoLink.addClass('buy-login');
                } else if (!user.first_name || !user.last_name) {
                    $buyPhotoLink.addClass('buy-update-profile');
                }
            });

            $(document).delegate(".buy-login", "click", function(event) {
                event.preventDefault();
                rnn.modules.login.loginDisplay("buy photos", "Login to purchase this photo");
            });

            $(document).delegate(".buy-update-profile", "click", function(event) {
                event.preventDefault();
                rnn.modules.user.get(function(user) {
                    updateProfile(user);
                });
            });
        }

        $fujiRedirect = $('.photo-fuji-redirect .buy-photo');
        if ($fujiRedirect.length) {
            fuji_redirection();
        }

    };

    function updateProfile(user) {

        $('#profileModal').modal();

        $updateUserDetailsLink = $('.update-user-details');

        $updateUserDetailsLink.click(function(event) {
            event.preventDefault();

            $.ajax({
                url: $updateUserDetailsLink.attr('href'),
                type: 'POST',
                dataType: 'json',
                data: $("form[name='update_details_form']").serialize(),
                success: function(data) {
                    if (data.updated) {
                        $('#profileModal').modal('hide');
                        purchase();
                    } else {
                        this.error(data)
                    }
                },
                error: function(data) {
                    var $form = $("form[name='update_details_form']"),
                        errorMessage = 'Unfortunately, an error occured. Please try again...';

                    if (data.errors) {
                        if (data.errors['__all__']) {
                            errorMessage = data.errors['__all__'];
                        }
                        $form.find('div.control-group.error').removeClass('error')
                        _.each(_.keys(data.errors), function (name) {
                            $('#id_' + name).closest('div').addClass('error');
                        });
                    }

                    $form.find('.alert').slideUp(200, function(){
                        $(this).remove();
                    });

                    rnn.modules.alert.show($form, {
                        message: errorMessage,
                        prepend: true,
                        type: 'error'
                    });
                }
            });
        });
    }

    function purchase() {
        var href = $buyPhotoLink.attr('href'),
            button = $.el.a({target:'_blank', href:href, 'class':'btn btn-primary btn-large modal-purchase'}, "Buy Now");

        $('#purchaseModal .modal-body').html(button);
        $('#purchaseModal').modal();

        $('.modal-purchase').click(function(){
            // Yes. no preventDefault
            $('#purchaseModal').modal('hide');
        });
    }

    function fuji_redirection() {

        $.ajax({
            url: $fujiRedirect.data('buy-photo-redirect-url'),
            type: 'POST',
            dataType: 'json',
            success: function(data) {
                if (data.redirect) {
                    window.location = data.redirect;
                } else {
                    error();
                }
            },
            error: function() { error(); }
        });
    }

    function error() {
          $buyPhotoLink.parent('div').hide();
          rnn.modules.alert.show('.buy-photo-info', 'Someone should be looking into it - please try again later. You may close this window.', 'Sorry, there was a problem!', null);
    };

    rnn.modules.register("photos", {
        init: initPhotos,
        updateProfile: updateProfile,
        purchase: purchase
    });

})(jQuery);
